import { Controller } from '@hotwired/stimulus'
import { mountElement, unmount } from '@planningcenter/tapestry/reactRender'

export default class ReactMountController extends Controller {
  connect() {
    mountElement(this.element)
  }

  disconnect() {
    if (this.isPermanent()) return
    unmount(this.element)
  }

  isPermanent() {
    return this.element.closest('[data-turbo-permanent]') !== null
  }
}
